import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { Accordion, AccordionDetails, AccordionSummary, Button, Typography } from '@mui/material';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import { useEffect, useState } from 'react';
import { StyledTableRow } from '../../../components/basics/StyledTableRow';
import { HeadCell, Order, TableHeaderComponent } from '../../../components/basics/TableHeaderComponent';
import { useTimeSheetsPageContext } from '../context/TimeSheetsPageContext';

const headCells: readonly HeadCell[] = [
  {
    id: 'primeiro_dia_do_mes',
    align: 'left',
    disablePadding: false,
    label: 'Data',
    disableSorting: true
  },
  {
    id: 'actions',
    align: 'right',
    disablePadding: false,
    label: 'Ações',
    disableSorting: true
  }
];

interface Props {
  onView: (item: any) => void;
}

export const TimeSheetsTable = ({ onView }: Props) => {
  const [order, setOrder] = useState<Order>('asc');
  const [orderBy, setOrderBy] = useState<string>('primeiro_dia_do_mes');
  const [selected, setSelected] = useState<string[]>([]);

  const [groupedItems, setGroupedItems] = useState<any>([]);

  const { timeSheets, handleOrderChange } = useTimeSheetsPageContext();

  const handleRequestSort = (property: string) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(String(property));
    handleOrderChange(property, isAsc ? 'desc' : 'asc');
  };

  const formatDate = (date: string) => {
    return date.split(' ')[0].replaceAll('-', '/');
  };

  useEffect(() => {
    setSelected([]);
    const groupItemsByYear = (items) => {
      return items.reduce((accumulator, currentItem) => {
        const year = currentItem.primeiro_dia_do_mes.trim().split(' ')[0].split('-')[2];

        if (!accumulator[year]) {
          accumulator[year] = [];
        }

        accumulator[year].push(currentItem);

        return accumulator;
      }, {});
    };

    if (timeSheets && timeSheets.results.length > 0) {
      const groupedItems = groupItemsByYear(timeSheets.results);

      const sortedGroupedItems = Object.keys(groupedItems).sort((a, b) => Number(b) - Number(a));

      let orderedGroupedItems = [];
      orderedGroupedItems = sortedGroupedItems.map((year) => {
        return { [year]: groupedItems[year] };
      });

      setGroupedItems(orderedGroupedItems);
    }
  }, [timeSheets]);

  return (
    <Box sx={{ width: '100%' }}>
      <Paper sx={{ width: '100%', mb: 2 }}>
        {groupedItems?.map((item, index) => {
          const year = Object.keys(item)?.[0];
          const values = item[year];

          return (
            <Accordion key={item + index}>
              <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1a-content" id="panel1a-header">
                <Typography variant="subtitle1" color="primary">
                  Comprovantes de {year}
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <TableContainer>
                  <Table aria-labelledby="tableTitle" size={'small'}>
                    <TableHeaderComponent
                      headCells={headCells}
                      numSelected={selected?.length}
                      order={order}
                      orderBy={orderBy}
                      onSelectAllClick={() => {}}
                      onRequestSort={handleRequestSort}
                      rowCount={timeSheets?.length || 0}
                      hideCheckbox
                    />
                    <TableBody>
                      {values?.map((row: any, index: number) => {
                        return (
                          <StyledTableRow key={row.primeiro_dia_do_mes + index}>
                            <TableCell align="left">{formatDate(row.primeiro_dia_do_mes)}</TableCell>
                            <TableCell align="right">
                              <Button
                                size="small"
                                variant="text"
                                startIcon={<VisibilityIcon />}
                                color="primary"
                                onClick={() => onView(row)}
                              >
                                Visualizar
                              </Button>
                            </TableCell>
                          </StyledTableRow>
                        );
                      })}
                    </TableBody>
                  </Table>
                </TableContainer>
              </AccordionDetails>
            </Accordion>
          );
        })}
      </Paper>
    </Box>
  );
};
